import { motion } from "framer-motion";
import { Activity, FileCheck, Lock, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/i18n";

const ICONS = [FileCheck, Lock, ShieldCheck, Activity];

export default function Security() {
  const { t } = useLanguage();

  return (
    <section id="seguranca" data-testid="security-section" className="relative border-y border-emerald-500/10 bg-[#050d0a] py-20 sm:py-28">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[700px] -translate-x-1/2 rounded-full bg-emerald-500/8 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mx-auto mb-14 max-w-2xl text-center"
        >
          <span className="eyebrow" data-testid="security-guarantee-badge">{t("security.eyebrow")}</span>
          <h2 className="font-display mt-4 text-3xl font-normal tracking-tight text-slate-50 sm:text-4xl">
            {t("security.title")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-400">{t("security.sub")}</p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {t("security.items").map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="rounded-2xl border border-emerald-500/15 bg-black/40 p-7 transition-colors duration-300 hover:border-emerald-500/35"
              >
                <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl border border-emerald-500/30 bg-emerald-500/10">
                  <Icon className="h-5 w-5 text-emerald-400" />
                </div>
                <h3 className="text-base font-semibold text-slate-100">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
